
const _captchaLoaded = () => {
		return new Promise((resolve) => {
			if (window.ocm?.captchaOptions?.captchaIsLoaded) {
				resolve(true);
			} else {
				document.addEventListener("ocmGoogleCaptchaLoaded", function() {
					resolve(true);
				});
			}
		});
}

export const captchaRender = async (captchaEl: HTMLElement, configObj: captchaParams) : Promise<number> => {
	await _captchaLoaded();
	
	const config: object = Object.assign({},
		{
					"size": "normal",
					"theme": "light",
					"badge": "inline",
				}, configObj);
	
	return grecaptcha.enterprise.render(captchaEl, config);
}

export const captchaExecute = async (widgetID:number) => {
	await _captchaLoaded();
	if(grecaptcha.enterprise.getResponse(widgetID).length > 0) {
		grecaptcha.enterprise.reset(widgetID);
	}
	return grecaptcha.enterprise.execute(widgetID);
}

export type captchaParams = {
	sitekey: string,
	size?: string,
	theme?: string,
	action?: string,
	badge?: string,
	callback?: Function,
	"error-callback"?: Function,
	"expired-callback"?: Function
}

/*
Hinweise:
	- captchaFunktionen für Google
		- enterprise v2 (checkbox and invisible)
		- enterprise checkboxsite keys
	_grecaptcha.scss blendet .grecaptcha-badge aus, wir verwenden einen eigenen Hinweis
*/